import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ChangePasswordForm } from './changePasswordForm';
import { ChangePasswordSuccess } from './changePasswordSuccess';
import { ROUTES } from '../../routes';

export const ChangePassword = () => (
  <Switch>
    <Route exact path={ROUTES.auth.changePassword.base} component={ChangePasswordForm} />
    <Route exact path={ROUTES.auth.changePassword.success} component={ChangePasswordSuccess} />
  </Switch>
);
